<div class="w-full flex flex-col gap-4 p-4">
    <app-page-header urlPath="/ncm"></app-page-header>

    <div
        class="w-full grid lg:grid-cols-[3fr_1fr] md:grid-cols-[2fr_1fr] grid-cols-1 gap-4 items-start"
        [formGroup]="form"
    >
        <p-card>
            <div class="w-full flex flex-col gap-4">
                <h1 class="text-2xl font-bold">Editar/Incluir Ncm</h1>

                <div
                    class="w-full grid sm:grid-cols-12 grid-cols-1 gap-4 items-end"
                >
                    <app-input
                        id="ncm"
                        label="Ncm"
                        formControlName="Ncm"
                        class="sm:col-span-4"
                    ></app-input>

                    <app-input-money
                        label="Mva original %"
                        formControlName="MvaOriginal"
                        class="sm:col-span-4"
                    ></app-input-money>

                    <app-input-money
                        label="Ipi %"
                        formControlName="AliqIpi"
                        class="sm:col-span-4"
                    ></app-input-money>

                    <app-date
                        label="Início da vigência"
                        formControlName="VigenciaInicial"
                        class="sm:col-span-4"
                    ></app-date>

                    <app-date
                        label="Fim da vigência"
                        formControlName="VigenciaFinal"
                        class="sm:col-span-4"
                    ></app-date>

                    <app-input
                        id="unidtributaria"
                        label="Unidade tributária"
                        formControlName="UnidTributaria"
                        class="sm:col-span-4"
                    ></app-input>

                    <app-input
                        id="descricao"
                        label="Descrição"
                        formControlName="Descricao"
                        class="sm:col-span-8"
                    ></app-input>

                    <app-input
                        id="categoria"
                        label="Categoria do Ncm"
                        formControlName="Categoria"
                        class="sm:col-span-4"
                    ></app-input>
                </div>

                <app-painel [title]="'Informações adicionais'">
                    <div
                        class="w-full grid sm:grid-cols-12 grid-cols-1 gap-4 items-end p-4"
                    >
                        <app-select
                            label="Cst Pis"
                            formControlName="CstPis"
                            [options]="selectCstPis"
                            class="sm:col-span-8"
                        ></app-select>

                        <app-input-money
                            label="Alíquota Pis"
                            formControlName="AliquotaPis"
                            class="sm:col-span-4"
                        ></app-input-money>

                        <app-select
                            label="Cst Ipi"
                            formControlName="CstIpi"
                            [options]="selectCstIpi"
                            class="sm:col-span-8"
                        ></app-select>

                        <app-input-money
                            label="Alíquota Ipi"
                            formControlName="AliqIpi"
                            class="sm:col-span-4"
                        ></app-input-money>

                        <app-select
                            label="Cst Cofins"
                            formControlName="CstCofins"
                            [options]="selectCstCofins"
                            class="sm:col-span-8"
                        ></app-select>

                        <app-input-money
                            label="Alíquota Cofins"
                            formControlName="AliquotaCofins"
                            class="sm:col-span-4"
                        ></app-input-money>

                        <app-input
                            id="baselegal"
                            label="Base Legal"
                            formControlName="BaseLegal"
                            class="sm:col-span-12"
                        ></app-input>

                        <app-text-area
                            id="descricaounidtrib"
                            label="Descrição da unidade tributária"
                            formControlName="DescricaoUnidTrib"
                            class="sm:col-span-12"
                        ></app-text-area>
                    </div>
                </app-painel>

                <div
                    class="w-full flex sm:flex-row flex-col gap-4 justify-end items-end"
                >
                    <app-button
                        variant="danger"
                        (click)="cancelar()"
                        class="md:max-w-45 w-full"
                        >Cancelar</app-button
                    >

                    <app-button
                        variant="success"
                        (click)="processarFormulario()"
                        class="md:max-w-45 w-full"
                        >Salvar</app-button
                    >
                </div>
            </div>
        </p-card>

        <p-card>
            <div class="w-full grid md:grid-cols-2 grid-cols-1 gap-4 items-end">
                <app-toogle
                    label="Sujeito a redução"
                    formControlName="Reducao"
                ></app-toogle>

                <app-toogle
                    label="Sujeito a ST"
                    formControlName="SujeitaST"
                ></app-toogle>
            </div>
        </p-card>
    </div>
</div>
